<template>
    <Form as="" :validation-schema="schema" v-slot="{ meta, handleSubmit }">
        <bs5-base-modal :title="$t('distributors.addTitle')" :visible="visible" @close="closeModal">
            <template v-slot:default>
                <form novalidate @submit.prevent="handleSubmit($event, addDistributor)">
                    <bs5-form-field id="addDistributorName" name="name" :label="$t('common.name')"
                        v-model="newDistributor.name" />
                    <bs5-form-field id="addDistributorDescription" name="description" :label="$t('common.description')"
                        v-model="newDistributor.description" />
                    <button type="submit" class="d-none" tabindex="-1" aria-hidden="true"></button>
                </form>
            </template>

            <template v-slot:footer>
                <bs5-cancel-button @click="closeModal" />
                <bs5-save-button :loading="saving" :disabled="!meta.valid"
                    @click="handleSubmit($event, addDistributor)">
                    <i class="bi bi-plus-lg"></i>{{ $t("common.add") }}
                </bs5-save-button>
            </template>
        </bs5-base-modal>
    </Form>
</template>

<script lang="ts">
import { t } from "@/helpers/i18n";
import { defineComponent, ref } from "vue";
import { Form } from "vee-validate";
import * as yup from "yup";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import { showToast } from "@/utils/toast";
import { nameMaxLength, optionalText, requiredText } from "@/utils/validation";

export default defineComponent({
    name: "AddDistributorModal",
    components: { Form },
    props: {
        visible: { type: Boolean, required: true },
    },
    emits: ["close", "distributor-added"],
    data() {
        return {
            newDistributor: ref<Distributor>({ name: "", description: "" }),
            saving: ref(false),
        };
    },
    computed: {
        schema() {
            return yup.object({
                name: requiredText(nameMaxLength),
                description: optionalText(),
            });
        },
    },
    watch: {
        visible(isVisible: boolean) {
            if (isVisible) {
                this.newDistributor = { name: "", description: "" };
            }
        },
    },
    methods: {
        async addDistributor() {
            try {
                this.saving = true;
                await distributorService.createDistributor(this.newDistributor);
                this.$emit("distributor-added");
                this.closeModal();
                showToast(t("distributors.added"), "success");
            } catch (error) {
                showToast(t("distributors.addFailed"), "error");
                console.error("Error adding distributor:", error);
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
